import { forwardRef } from 'react';
import type { WrapperFC } from '@george-labs.com/design-system';
import { Button } from '@george-labs.com/design-system';

import { t } from '@luna/i18n';

interface ButtonProps {
    'data-cy': string;
}

export const CardMenuDropdownToggle: WrapperFC = forwardRef<HTMLButtonElement, ButtonProps>(
    ({ 'data-cy': dataCy, ...forwardedProps }, ref) => {
        return (
            <Button
                ref={ref}
                variant={Button.VARIANT.TERTIARY}
                data-cy={dataCy}
                icon={Button.ICON.MORE_HORIZONTAL}
                hiddenLabel={Button.HIDDEN_LABEL.ALWAYS}
                fullWidth={Button.FULL_WIDTH.NEVER}
                {...forwardedProps}
            >
                {t('mainOverview.action.moreActions_a11y')}
            </Button>
        );
    },
);

CardMenuDropdownToggle.wrapsComponent = Button;
